import React, { useEffect } from "react";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import EventNoteIcon from "@mui/icons-material/EventNote";
import PeopleIcon from "@mui/icons-material/People";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import SendIcon from '@mui/icons-material/Send';
import judicialLogo from "../Images/judicialLogo.png";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import DownloadIcon from "@mui/icons-material/Download";
import "../Style/Home.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCourses,
  getAllEnquiries,
  getAllStudents,
  openCreateNewCourseDialog,
} from "../Redux/Dashboard/DashboardSlice";
import { useNavigate } from "react-router-dom";
import { getCoursesDetail, getCoursesVideos } from "../Redux/Auth/AuthSlice";

const AdminHome = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selector = useSelector((s) => s.DashboardSlice);
  const selectorAuth = useSelector((s) => s.AuthSlice);

  const coursesData = selector.coursesData || [];
  const getStudents = selector.getStudents || [];
  const getEnquiries = selector.getEnquiries || [];
  const getCoursesVideo = selectorAuth.getCoursesVideo || [];


  useEffect(() => {
    dispatch(getAllCourses({ is_paid: "" }));
    dispatch(getAllStudents());
    dispatch(getAllEnquiries());
    dispatch(getCoursesVideos());
    dispatch(getCoursesDetail());
  }, [dispatch]);

  const handleCardClick = (path) => (event) => {
    event.stopPropagation(); // Prevent event bubbling
    try {
      navigate(path);
      window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top
    } catch (error) {
      console.error("Navigation failed:", error);
    }
  };

  const cardData = [
    // {
    //   title: "Courses",
    //   count: coursesData.length,
    //   icon: <EventNoteIcon className="homeDashboardIcon" />,
    //   color: "#1e3a8a",
    //   gradient: "linear-gradient(135deg, #1e3a8a,rgb(13, 27, 51))",
    //   onClick: handleCardClick("/courses"),
    // },
    // {
    //   title: "Create Course",
    //   count: "+",
    //   icon: <FileUploadIcon className="homeDashboardIcon" />,
    //   color: "#22c55e",
    //   gradient: "linear-gradient(135deg,rgb(43, 187, 96),rgb(5, 41, 18))",
    //   badge: "New!",
    //   onClick: () => dispatch(openCreateNewCourseDialog(true)),
    // },
    // {
    //   title: "Students",
    //   count: getStudents.length,
    //   icon: <PeopleIcon className="homeDashboardIcon" />,
    //   color: "#9333ea",
    //   gradient: "linear-gradient(135deg, #9333ea,rgb(48, 13, 80))",
    //   onClick: handleCardClick("/studentsList"),
    // },
    // {
    //   title: "Transactions",
    //   count: getTransactions.length,
    //   icon: <CurrencyRupeeIcon className="homeDashboardIcon" />,
    //   color: "#f59e0b",
    //   gradient: "linear-gradient(135deg, #f59e0b,rgb(83, 44, 16))",
    //   onClick: handleCardClick("/transaction"),
    // },
    // {
    //   title: "All Videos",
    //   count: getCoursesVideo.length,
    //   icon: <OndemandVideoIcon className="homeDashboardIcon" />,
    //   color: "#f59e0b",
    //   gradient: "linear-gradient(135deg, #3b82f6,rgb(11, 44, 85))",
    //   onClick: handleCardClick("/allVideos"),
    // },
    // {
    //   title: "Download Videos",
    //   icon: <DownloadIcon className="homeDashboardIcon" />,
    //   color: "#f59e0b",
    //   gradient: "linear-gradient(135deg, #10b981,rgb(10, 73, 50))",
    //   onClick: handleCardClick("/allVideosDetails"),
    // },
    // {
    //   title: "Send Notification",
    //   icon: <FontAwesomeIcon icon={faPaperPlane} className="homeDashboardIcon" />,
    //   color: "#f59e0b",
    //   gradient: "linear-gradient(135deg,rgb(26, 28, 134),rgb(4, 11, 51))",
    //   onClick: handleCardClick("/notification"),
    // },
    // {
    //   title: "Live Section",
    //   icon: <FontAwesomeIcon icon={faYoutube} className="homeDashboardIcon" />,
    //   color: "#f59e0b",
    //   gradient: "linear-gradient(135deg,rgb(204, 43, 123),rgb(51, 4, 45))",
    //   onClick: handleCardClick("/live-session"),
    // },


    {
      title: "Courses",
      count: coursesData.length,
      icon: <EventNoteIcon className="homeDashboardIcon" />,
      color: "#1e3a8a",
      gradient: "linear-gradient(135deg, #1e3a8a, #3b82f6)",
      onClick: handleCardClick("/courses"),
    },
    {
      title: "Create Course",
      count: "+",
      icon: <FileUploadIcon className="homeDashboardIcon" />,
      color: "#22c55e",
      gradient: "linear-gradient(135deg, #22c55e, #16a34a)",
      badge: "New!",
      onClick: () => dispatch(openCreateNewCourseDialog(true)),
    },
    {
      title: "Students",
      count: getStudents.length,
      icon: <PeopleIcon className="homeDashboardIcon" />,
      color: "#9333ea",
      gradient: "linear-gradient(135deg, #9333ea, #a855f7)",
      onClick: handleCardClick("/studentsList"),
    },
    {
      title: "Enquiry",
      count: getEnquiries.length,
      icon: <ContactSupportIcon className="homeDashboardIcon" />,
      color: "#f59e0b",
      gradient: "linear-gradient(135deg, #f59e0b, #f97316)",
      onClick: handleCardClick("/enquiry"),
    },
    {
      title: "All Videos",
      count: getCoursesVideo.length,
      icon: <OndemandVideoIcon className="homeDashboardIcon" />,
      color: "#f59e0b",
      gradient: "linear-gradient(135deg, #3b82f6, #60a5fa)",
      onClick: handleCardClick("/allVideos"),
    },
    {
      title: "Download Videos",
      icon: <DownloadIcon className="homeDashboardIcon" />,
      color: "#f59e0b",
      gradient: "linear-gradient(135deg, #10b981, #34d399)",
      onClick: handleCardClick("/allVideosDetails"),
    },
    {
      title: "Send Notification",
      icon: <SendIcon className="homeDashboardIcon" />,
      color: "#f59e0b",
      gradient: "linear-gradient(135deg,rgb(26, 28, 134),rgb(4, 11, 51))",
      onClick: handleCardClick("/notification"),
    },
    // {
    //   title: "Live Section",
    //   icon: <FontAwesomeIcon icon={faYoutube} className="homeDashboardIcon" />,
    //   color: "#f59e0b",
    //   gradient: "linear-gradient(135deg,rgb(204, 43, 123),rgb(51, 4, 45))",
    //   onClick: handleCardClick("/live-session"),
    // },
  ];

  return (
    <div className="homeAdminHomeMain">
      <img className="homeJudicialLogo" src={judicialLogo} alt="Judicial Logo" />
      <Box sx={{ p: { xs: 2, sm: 3, md: 4 } }} className="homeDashboardWrapper">
        <Typography variant="h4" fontWeight="bold" className="homeDashboardHeading">
          Admin Dashboard
        </Typography>
        <Grid container spacing={3} className="homeCardGrid">
          {cardData.map((card, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={6}
              key={index}
              className={`homeCardItem homeCardItem-${index}`}
            >
              <Card
                className="homeGlassCard"
                sx={{
                  background: card.gradient,
                  color: "#f1f5f9",
                  borderRadius: "20px",
                  cursor: "pointer",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.05)", // Simplified hover effect
                    // boxShadow: `0 10px 20px ${card.color}80`,
                  },
                }}
                onClick={card.onClick}
                role="button" // Accessibility improvement
                tabIndex={0} // Make card focusable
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    card.onClick(e); // Support keyboard navigation
                  }
                }}
              >
                <CardContent
                  className="homeCardContent"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    py: 3,
                    px: 4,
                  }}
                >
                  <Box className="homeCardIconWrapper">
                    {card.icon}
                    {card.badge && <span className="homeCardBadge">{card.badge}</span>}
                  </Box>
                  <Box className="homeCardTextWrapper" sx={{ textAlign: "right" }}>
                    <Typography
                      className="homeCardTitle"
                      sx={{ fontSize: { xs: "18px", md: "22px" }, fontWeight: 700 }}
                    >
                      {card.title}
                    </Typography>
                    <Typography
                      className="homeCardCount"
                      sx={{ fontSize: { xs: "24px", md: "32px" }, fontWeight: 800, mt: 1 }}
                    >
                      {card.count}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </div>
  );
};

export default AdminHome;


// {
//   title: "Courses",
//   count: coursesData.length,
//   icon: <EventNoteIcon className="homeDashboardIcon" />,
//   color: "#1e3a8a",
//   gradient: "linear-gradient(135deg, #1e3a8a, #3b82f6)",
//   onClick: handleCardClick("/courses"),
// },
// {
//   title: "Create Course",
//   count: "+",
//   icon: <FileUploadIcon className="homeDashboardIcon" />,
//   color: "#22c55e",
//   gradient: "linear-gradient(135deg, #22c55e, #16a34a)",
//   badge: "New!",
//   onClick: () => dispatch(openCreateNewCourseDialog(true)),
// },
// {
//   title: "Students",
//   count: getStudents.length,
//   icon: <PeopleIcon className="homeDashboardIcon" />,
//   color: "#9333ea",
//   gradient: "linear-gradient(135deg, #9333ea, #a855f7)",
//   onClick: handleCardClick("/studentsList"),
// },
// {
//   title: "Transactions",
//   count: getTransactions.length,
//   icon: <CurrencyRupeeIcon className="homeDashboardIcon" />,
//   color: "#f59e0b",
//   gradient: "linear-gradient(135deg, #f59e0b, #f97316)",
//   onClick: handleCardClick("/transaction"),
// },
// {
//   title: "All Videos",
//   count: getCoursesVideo.length,
//   icon: <OndemandVideoIcon className="homeDashboardIcon" />,
//   color: "#f59e0b",
//   gradient: "linear-gradient(135deg, #3b82f6, #60a5fa)",
//   onClick: handleCardClick("/allVideos"),
// },
// {
//   title: "Download Videos",
//   icon: <DownloadIcon className="homeDashboardIcon" />,
//   color: "#f59e0b",
//   gradient: "linear-gradient(135deg, #10b981, #34d399)",
//   onClick: handleCardClick("/allVideosDetails"),
// },